import { render } from "./DateHistoryDetailView.vue?vue&type=template&id=548ab05a&scoped=true"
import script from "./DateHistoryDetailView.vue?vue&type=script&lang=js"
export * from "./DateHistoryDetailView.vue?vue&type=script&lang=js"

import "./DateHistoryDetailView.vue?vue&type=style&index=0&id=548ab05a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548ab05a"]])

export default __exports__